import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Row, Col, ButtonGroup, Button, Card, CardBody, CardTitle, CardText } from 'reactstrap';
import { Redirect, Link } from "react-router-dom";
import { withTranslation } from 'react-i18next';

import PageTitle from '../../../components/PageTitle/PageTitle';
import { loadCronTask, deleteCronTask } from '../../../redux/modules/cron_tasks';

class CronTaskDelete extends Component<{}> {
    componentDidMount() {
        const cron_taskId = this.props.match.params.cron_taskId;
        // Load cron_tasks on component mount
        this.props.dispatchLoadCronTask(cron_taskId);
    }

    deleteCronTask(cron_taskId) {
        this.props.dispatchDeleteCronTask(cron_taskId);
    }

    render() {
        const { cron_task, isLoading, cron_taskSuccessfullyDeleted } = this.props.cron_tasks;
        const { t } = this.props;

        let title = <span>{t("cron_tasks.cron_task", {count: 42})}</span>;
        if (cron_task)
            title = (
                <span>
                    {t("cron_tasks.cron_task", {count: 1})}
                    <small> | { cron_task.name } </small>
                </span>
            );

        const actions =
        <div>
            <ButtonGroup>
                <Button tag={Link} to="/cron_tasks" color="warning" size="sm">
                    <i className="fa fa-arrow-left"></i>&nbsp;{t("common.back")}
                </Button>
            </ButtonGroup>
        </div>

        return (
            <div className="CronTaskDelete">
                <PageTitle icon="tasks" title={ title } actions={ actions } />

                {cron_taskSuccessfullyDeleted &&
                    <Redirect to="/cron_tasks"/>
                }

                {cron_task &&
                    <Row>
                        <Col>
                            <Card>
                                <CardBody>
                                    <CardTitle><i className="fa fa-warning"></i>&nbsp;{ t('cron_tasks.confirm_delete')}</CardTitle>
                                    <CardText tag="div">
                                        <div><b>{t("cron_tasks.name")}</b>: { cron_task.name }</div>
                                        <Row>
                                            <Col className="text-center">
                                                <Button tag={Link} to="/cron_tasks" color="warning">
                                                    <i className="fa fa-arrow-left"></i>&nbsp;{ t('common.cancel')}
                                                </Button>&nbsp;
                                                <Button color="danger" onClick={(e) => this.deleteCronTask(cron_task._id)} disabled={isLoading}>
                                                    {isLoading ?
                                                        <span>
                                                            &nbsp;<i className="fa fa-spinner fa-spin"></i>
                                                        </span>
                                                        :
                                                        <span>
                                                            <i className="fa fa-trash"></i>&nbsp;
                                                            { t('common.delete')}
                                                        </span>
                                                    }
                                                </Button>
                                            </Col>
                                        </Row>
                                    </CardText>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                }
            </div>
        );
    }
}

const mapDispatchToProps = {
    dispatchLoadCronTask: (cron_taskId) => loadCronTask(cron_taskId),
    dispatchDeleteCronTask: (cron_taskId) => deleteCronTask(cron_taskId)
}

const mapStateToProps = state => ({
    cron_tasks: state.cron_tasks
})

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('translations')(CronTaskDelete))
